import { Filter, Hash, Label, Setup } from '@doist/icons/brand';
import { Box, Card, Divider, Hidden, Image, Text } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import css from './setup-card.module.css';
import type { TemplatePreview } from 'services/templates/types';
export type SetupCardProps = {
  template: TemplatePreview;
  forceNarrowStyle?: boolean;
};
export function SetupCard({
  template,
  forceNarrowStyle
}: SetupCardProps) {
  const {
    t
  } = useTranslation('templates');
  const data = [{
    icon: Hash,
    count: template.project_count,
    name: t('counts.projects')
  }, {
    icon: Filter,
    count: template.filter_count,
    name: t('counts.filters')
  }, {
    icon: Label,
    count: template.label_count,
    name: t('counts.labels')
  }];
  return <Box className={cn(css.cardContainer, {
    [css.forceNarrow]: forceNarrowStyle
  })} data-sentry-element="Box" data-sentry-component="SetupCard" data-sentry-source-file="setup-card.tsx">
            <Card className={css.setupCard} data-sentry-element="Card" data-sentry-source-file="setup-card.tsx">
                <Box className={css.image} style={{
        '--bg-color': template.background_color
      }} data-sentry-element="Box" data-sentry-source-file="setup-card.tsx">
                    <Image src={template.thumbnail_image} width={100} height={100} alt="" data-sentry-element="Image" data-sentry-source-file="setup-card.tsx" />
                    <Divider data-sentry-element="Divider" data-sentry-source-file="setup-card.tsx" />
                </Box>

                <Box className={cn(css.info, 'pb-16 pi-16')} data-sentry-element="Box" data-sentry-source-file="setup-card.tsx">
                    <Box className={cn(css.content, 'mbe-8')} data-sentry-element="Box" data-sentry-source-file="setup-card.tsx">
                        <Text size="minor-base" weight="semibold" data-sentry-element="Text" data-sentry-source-file="setup-card.tsx">
                            <a className={css.link} href={`/templates/${template.id}`}>
                                {template.name}
                            </a>
                        </Text>
                        <Text size="body-xs" weight="medium" className={cn(css.description, 'pbs-8')} data-sentry-element="Text" data-sentry-source-file="setup-card.tsx">
                            {template.short_description}
                        </Text>
                    </Box>
                    <Box className={css.details} data-sentry-element="Box" data-sentry-source-file="setup-card.tsx">
                        <Box className={css.templateType} data-sentry-element="Box" data-sentry-source-file="setup-card.tsx">
                            <Box className={css.icon} data-sentry-element="Box" data-sentry-source-file="setup-card.tsx">
                                <Setup data-sentry-element="Setup" data-sentry-source-file="setup-card.tsx" />
                            </Box>
                            <Text size="body-xs" data-sentry-element="Text" data-sentry-source-file="setup-card.tsx">{t('setup')}</Text>
                        </Box>
                        <Divider data-sentry-element="Divider" data-sentry-source-file="setup-card.tsx" />
                        <Box className={css.countList} data-sentry-element="Box" data-sentry-source-file="setup-card.tsx">
                            {data.map(item => <Box key={`data-${item.name}`}>
                                    <Box className={css.icon}>
                                        <item.icon />
                                    </Box>
                                    <Text size="body-xs">
                                        {item.count}{' '}
                                        {!forceNarrowStyle ? <Hidden below="md" tag="span">
                                                {t(item.name)}
                                            </Hidden> : null}
                                    </Text>
                                </Box>)}
                        </Box>
                    </Box>
                </Box>
            </Card>
        </Box>;
}